import { EMail } from "./email";

export class Notifications {
  private email: EMail;

  constructor(email: EMail) {
    this.setEmail(email);
  }

  getEmail() {
    return this.email;
  }

  setEmail(email: EMail) {
    this.email = email;
  }

  toJSON() {
    return {
      email: this.email.toJSON(),
    };
  }
}
